import Close from "components/atoms/Close";
import LoadingBox from "components/molecules/LoadingBox";
import Modal from "components/organisms/Modal";
import colors from "constants/colors";
import Cookies from "js-cookie";
import React, { useEffect, useState } from "react";
import styled from "styled-components/macro";
import { useSelector } from "./useApp";

export const useHomeGame = () => {
  const [gamesPopup, setGamesPopup] = useState<GamesPopup>({
    isOpen: false,
    data: null,
  });

  const [onCloseRequest, setOnCloseRequest] = useState(true);
  const [diffDays, setDiffDays] = useState<number>();

  const receiveMessage = (event: any) => {
    if (event) {
      if (event.data === "game-modal-processing") {
        setOnCloseRequest(false);
      }
      if (event.data === "game-modal-processed") {
        setOnCloseRequest(true);
      }
      if (event.data === "copy-code") {
        let _gameCode = Cookies.get("_cg_");
        if (_gameCode) {
          Cookies.set(
            "copied-code", //copied-code
            "1",
            {
              expires: diffDays,
            },
          );
        }
      }
      if (event.data && event.data.event_id === "code_gaming") {
        const {
          data: { v1, expired },
        } = event.data;
        const parts = expired.split("/");
        const validDate = new Date(
          `${parts[1]}/${Number(parts[0]) + 1}/${parts[2]}`,
        );
        if (validDate) {
          setDiffDays(validDate.getDate() - new Date().getDate()); // tính ngày hết hạn của code
          Cookies.set(
            "_cg_", //code_gaming
            { v1, expired },
            {
              expires: diffDays,
            },
          );
        }
        sessionStorage.setItem("_kcg_", "1"); //ket qua code_gaming
        window.history.pushState("", "Kết quả quay số", "/ket-qua");
      }
      if (event.data === "close-game-modal") {
        setGamesPopup({
          isOpen: false,
          data: null,
        });
      }
    }
  };

  useEffect(() => {
    const check = sessionStorage.getItem("_kcg_");
    if (!check) {
      window.history.pushState("", "Trang chủ", `/${window.location.search}`);
    }
  }, []);

  useEffect(() => {
    if (window.addEventListener)
      // IE9+
      window.addEventListener("message", receiveMessage, false);
    else if (window.attachEvent) {
      // IE8-
      window.attachEvent("onmessage", receiveMessage);
    } else {
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { userInfor: userInformation } = useSelector(state => state);

  useEffect(() => {
    const groupAdminEmailToTestOnly = [
      "hoangnguyen8991@gmail.com",
      "minhhoang.nguyen@daikin.com.vn",
    ];
    const todaysDate = new Date();
    if (
      userInformation &&
      userInformation.email &&
      groupAdminEmailToTestOnly.includes(userInformation.email)
    ) {
      setGamesPopup({
        isOpen: true,
        data: null,
      });
    } else {
      let userOpenedGameModal = Cookies.get("SSIDIS");
      // user is not opened game modal:
      if (!userOpenedGameModal) {
        // if user remove storeinfo->will open modal.
        setGamesPopup({
          isOpen: true,
          data: null,
        });
        // save the first time open game modal:
        Cookies.set("SSIDIS", todaysDate.toString(), {
          expires: 1,
        });
      } else {
        // user is opened game modal:
        const userSavedDate = new Date(userOpenedGameModal);
        if (
          userSavedDate.setHours(0, 0, 0, 0) !== todaysDate.setHours(0, 0, 0, 0)
        ) {
          // Is new day:
          setGamesPopup({
            isOpen: true,
            data: null,
          });
          // save new date:
          Cookies.set("SSIDIS", todaysDate.toString(), {
            expires: 1,
          });
        }
      }
    }
  }, [userInformation]);

  const [popupLoading, setPopupLoading] = useState(true);

  const modalGame = gamesPopup.isOpen && (
    <Modal
      portalClassName="gamesPopup"
      isOpen={gamesPopup.isOpen}
      resetModal
      onCloseRequest={
        onCloseRequest
          ? () => {
            setGamesPopup({ isOpen: false, data: null });
          }
          : undefined
      }
      injectHTML={
        <ExtendedClose
          color={colors.richElectricBlue}
          background="transparent"
          onClick={
            onCloseRequest
              ? () => {
                setGamesPopup({ isOpen: false, data: null });
              }
              : undefined
          }
          className="closeGamesPopupButton"
        />
      }
    >
      {popupLoading && <LoadingBox type="fill" />}
      <iframe src="https://quay-so.com/" title="https://quay-so.com/" />
    </Modal>
  );

  return {
    popupLoading,
    modalGame,
    setPopupLoading,
  };
};

const ExtendedClose = styled(Close)`
  z-index: 22 !important;
`;
